import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { formatDate, formatTime, formatCurrency } from '../../lib/utils';
import { Slot, SlotConsultant } from '../../types';

interface BookingSummaryProps {
  slot: Slot;
  selectedConsultant: SlotConsultant;
}

export const BookingSummary: React.FC<BookingSummaryProps> = ({ slot, selectedConsultant }) => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="text-lg">Booking Summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Date:</span>
          <span className="font-medium">{formatDate(slot.time)}</span>
        </div>
        
        <div className="flex justify-between">
          <span className="text-muted-foreground">Time:</span>
          <span className="font-medium">{formatTime(slot.time)}</span>
        </div>
        
        <div className="flex justify-between">
          <span className="text-muted-foreground">Duration:</span>
          <span className="font-medium">{slot.duration} minutes</span>
        </div>
        
        <div className="flex justify-between">
          <span className="text-muted-foreground">Consultant:</span>
          <span className="font-medium">{selectedConsultant.first_name}</span>
        </div>
        
        <div className="flex justify-between text-lg font-bold border-t pt-3">
          <span>Total Price:</span>
          <span className="text-primary">{formatCurrency(slot.pricing.price)}</span>
        </div>
      </CardContent>
    </Card>
  );
};
